import axiosAuth from '../../axiosPublic';

async function index() {
  let response = await axiosAuth.get('/public/dashboard_summary');
  return response.data;
}

export default {
  index,
};
